<template>
  <el-card>
    <el-form inline ref="searchInfo" :model="info">
      <el-form-item prop="isShield">
        <el-select v-model="info.isShield" placeholder="选择展示状态" clearable>
          <el-option label="已展示" value="0"></el-option>
          <el-option label="未展示" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="orderTop">
        <el-select v-model="info.isTop" placeholder="选择置顶状态" clearable>
          <el-option label="已置顶" value="1"></el-option>
          <el-option label="未置顶" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="dateRange">
        <el-date-picker v-model="dateRange" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="mb20">
      <el-dropdown @command="batchOperation" v-if="$ButtonShow('TOE_EDT_02')">
        <el-button type="primary">
          批量操作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="0" v-if="$ButtonShow('TOE_EDT_02')">批量展示</el-dropdown-item>
          <el-dropdown-item command="1" v-if="$ButtonShow('TOE_EDT_02')">批量取消展示</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-table class="global-table" v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="游客昵称" show-overflow-tooltip prop="nickname"></el-table-column>
      <el-table-column label="评价内容" show-overflow-tooltip prop="content"></el-table-column>
      <el-table-column label="评价日期" show-overflow-tooltip prop="ctime"></el-table-column>
      <el-table-column label="展示状态" show-overflow-tooltip prop="isShield">
        <template v-slot="{ row }">
          <el-switch v-model="row.isShield" active-color="#13ce66" inactive-color="#bbbbbb" active-value="0"
            inactive-value="1" @change="showState(row, 'isShield')" :disabled="!$ButtonShow('TOE_EDT_01')">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="置顶状态" show-overflow-tooltip prop="isTop">
        <template v-slot="{ row }">
          <el-switch v-model="row.isTop" active-color="#13ce66" inactive-color="#bbbbbb" active-value="1"
            inactive-value="0" @change="showState(row, 'isTop')" :disabled="!$ButtonShow('TOE_EDT_03')">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="110px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDelete(row.evaluateId)" v-if="$ButtonShow('TOE_DEL_02')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
  </el-card>
</template>

<script>
export default {
  name: 'EvaluateDetail',
  data() {
    return {
      dateRange: [],
      info: {
        orderTop: '0',
        isShield: '',
        startTime: '',
        endTime: ''
      },
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      bacthList: []
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  methods: {
    handleSelectionChange(val) {
      val.forEach((item) => {
        this.bacthList.push(item.evaluateId)
      })
    },
    batchOperation(val) {
      if (this.bacthList.length > 0) {
        this.$axios.post(this.$apis.tourist.batchShield, {
          isShield: val,
          evaluateIds: this.bacthList
        }).then(() => {
          this.bacthList = []
          this.$message.success('设置成功')
          this.loadData()
        })
      } else {
        this.$message.error('请先选择批量操作的数据')
      }
    },
    showState(row, type) {
      const url = type === 'isShield' ? this.$apis.tourist.shield : this.$apis.tourist.top
      this.$axios.post(url, {
        evaluateId: row.evaluateId
      }).then(() => {
        this.$message.success('设置成功')
      }).finally(() => {
        this.loadData()
      })
    },
    loadData() {
      this.loading = true
      if (this.dateRange) {
        this.info.startTime = this.dateRange[0] || ''
        this.info.endTime = this.dateRange[1] || ''
      } else {
        this.info.startTime = ''
        this.info.endTime = ''
      }
      this.$axios.get(this.$apis.tourist.selectTouristEvaluateByPage, {
        ...this.info,
        objectId: this.id,
        page: this.page,
        size: this.size
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || 0
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onDelete(evaluateId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteDataTouristEvaluate, {
          evaluateId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
